module.exports = __webpack_public_path__ + "static/media/clock-money-icon.41cf5db4.svg";